import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";
import { permanentRedirect } from "@/lib/legacyRedirects";

/** Gammal URL – permanent omdirigering (301). */
export const Route = createFileRoute("/spotpris/se1")({
  head: () => seoHead("/spotpris/se1"),
  beforeLoad: () => permanentRedirect("/spotpris/elomrade-se1"),
});
